<form clrForm [formGroup]="searchForm">
  <div class="clr-row">
    <div class="clr-col-6">
      <subs-input
        controlName="wUPILastName"
        label="WU PI Last Name"
        helperText="Will return projects that contain the entered name."
      >
      </subs-input>

      <subs-input
        controlName="proposalId"
        label="Proposal ID"
        helperText="Will return projects that contain the entered ID."
      >
      </subs-input>

      <subs-input
        label="Grant Worktag"
        placeholder="Alphanumeric"
        controlName="grantWorkTag"
        helperText="Will return projects that contain the entered Grant Worktag."
      >
      </subs-input>

      <subs-input
        label="Tracking Num"
        controlName="trackingNum"
        helperText="Will return projects that contain the entered
          number."
      >
      </subs-input>

      <subs-input
        controlName="subrecipient"
        helperText="Will return projects that contains the entered text."
      >
      </subs-input>

      <subs-select
        label="Days Since Submission"
        class="clr-col-lg-auto"
        controlName="daysSinceSubmission"
        containerStyle="margin-top: 0"
      >
        <option value="" selected>&nbsp;</option>
        <option value="lt30" selected="selected">&lt;30 days</option>
        <option value="31-60">31-60 days</option>
        <option value="61-90">61-90 days</option>
        <option value="gt90">&gt; 90 days</option>
      </subs-select>

      <div class="clr-row">
        <div class="clr-col-12">
          <subs-assigned-ga
            class="c-worklist-osrs-ga"
            controlName="assignedGA"
            label="OSRS GA"
          >
          </subs-assigned-ga>
        </div>
      </div>

      <div class="clr-row">
        <div class="clr-col-5">
          <subs-checkbox
            label="Show Repeat Submissions"
            controlName="showRepeatSubmissions"
          >
          </subs-checkbox>
        </div>
      </div>
    </div>

    <div class="clr-col-6">
      <subs-input
        controlName="wUPIFirstName"
        label="WU PI First Name"
        helperText="Will return projects that contain the entered
          name."
      >
      </subs-input>

      <subs-input
        label="Award Dept"
        controlName="awardDept"
        helperText="Will return projects that contains the entered text."
      >
      </subs-input>

      <subs-input
        label="Issuing Dept"
        controlName="issuingDept"
        helperText="Will return projects that contains the entered text."
      >
      </subs-input>

      <subs-input
        label="Agreement Num"
        controlName="agreementNum"
        helperText="Will return projects that contains the entered text."
      >
      </subs-input>

      <subs-input
        label="PI Cost Center"
        placeholder="Alphanumeric"
        controlName="costCenterId"
        helperText="Will return projects that contain the entered PI Cost Center associated with the Grant Worktag."
      >
      </subs-input>

      <subs-subaward-status-multi-select
        class="clr-col-lg-auto"
        containerStyle="margin-top: 0"
        controlName="statuses"
        [statuses]="activeStatusList"
        [displayDAStatus]="searchForm.controls.DAStatus.value == true"
      >
      </subs-subaward-status-multi-select>

      <div class="clr-row c-worklist-type-row">
        <div class="clr-col-5">
          <subs-select
            class="clr-col c-worklist-foreign-select"
            controlName="foreignEntity"
            label="Foreign Institution"
            [horizontal]="true"
          >
            <option value=""></option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </subs-select>
        </div>
        <div class="clr-col-7">
          <subs-select
            class="clr-col c-worklist-subcontract-select"
            controlName="subContractType"
            label="Subcontract Type"
            [horizontal]="true"
          >
            <option value=""></option>
            <option value="Fixed Fee">Fixed Fee</option>
            <option value="Fixed Price">Fixed Price</option>
            <option value="Combined FA & CR">Combined FA & CR</option>
            <option value="Cost Reimbursable">Cost Reimbursable</option>
          </subs-select>
        </div>
      </div>

      <subs-checkbox label="Include DA Statuses" controlName="DAStatus">
      </subs-checkbox>
    </div>
  </div>

  <div class="clr-row">
    <div class="clr-col-11" style="margin-top: 24px">
      <subs-alert [alertBehavior]="alertSubject$"></subs-alert>
      <button
        type="button"
        class="btn btn-primary"
        [clrLoading]="submitState | async"
        (click)="search()"
        data-test-id="search-btn"
        [disabled]="!searchForm.valid"
      >
        Search
      </button>

      <button
        type="button"
        class="btn btn-outline"
        (click)="clear()"
        data-test-id="clear-btn"
      >
        Clear
      </button>
      <button
        type="button"
        *ngIf="searchResult.length"
        class="btn btn-outline"
        [clrLoading]="submitState | async"
        (click)="downloadReport()"
        data-test-id="generate-report-btn"
      >
        Export
      </button>
    </div>
    <div class="clr-col-1" style="margin-top: 24px; padding-top: 24px">
      <span *ngIf="searchResult && searchResult.length >= 0">{{
        searchResultCount
        }}</span>
    </div>
  </div>

  <div
    *ngIf="shouldShowNoResultsMessage | async"
    class="alert alert-warning"
    role="alert"
  >
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper">
          <clr-icon class="alert-icon" shape="exclamation-triangle"></clr-icon>
        </div>
        <span class="alert-text" data-test-id="alert-msg">
          There were no results for your search.
        </span>
      </div>
    </div>
  </div>

  <div
    *ngIf="shouldShowMaxResultsMessage | async"
    class="alert alert-warning"
    role="alert"
  >
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper">
          <clr-icon class="alert-icon" shape="exclamation-triangle"></clr-icon>
        </div>
        <span class="alert-text" data-test-id="alert-msg">
          Only 300 projects are being shown. Export to see the whole list
        </span>
      </div>
    </div>
  </div>
</form>

<subs-co-worklist-result-grid
  [searchResults]="filteredResults"
  [statuses]="activeStatusList"
  data-test-id="search-result-grid"
  (toggle)="onPriorityChange($event)"
>
</subs-co-worklist-result-grid>
